// regular vue mixins don't work with vue 2.x versions
import { LocalizedString } from '@onrunning/backstage-models';
import moment from 'moment';
import { globalConstants } from '../constants/global.constants';
import { useUserStore } from '../stores/user';

const isString = (value: any): value is string => typeof value === 'string';

/**
 * @deprecated Please use composables/format.ts instead
 */
export const formatMixins = {
  formatDateToLocaleStringIgnoringTime(date: Date | string, locale: string) {
    return this.formatDate(moment(date).format(globalConstants.dateFormat), locale, {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    });
  },
  formatDate(
    inputDate: Date | string,
    locale: string,
    options: Intl.DateTimeFormatOptions = {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      timeZone: 'UTC',
    },
  ) {
    const date = isString(inputDate) ? new Date(inputDate) : inputDate;

    if (date && Object.prototype.toString.call(date) === '[object Date]') {
      if (!isNaN(date.getTime())) {
        return new Intl.DateTimeFormat(locale?.replace('_', '-'), options).format(date);
      }
    }

    return '';
  },
  formatDateNoUTC(date: Date | string, locale: string) {
    return this.formatDate(date, locale, { day: '2-digit', month: '2-digit', year: 'numeric' });
  },
  formatCurrency(currencyCode: string | undefined, value: any, locale: string, ignoreZero = true) {
    if (!currencyCode) {
      return '';
    }

    if (value || (value === 0 && !ignoreZero)) {
      try {
        return new Intl.NumberFormat(locale?.replace('_', '-'), {
          style: 'currency',
          currency: currencyCode,
          currencyDisplay: 'code',
          currencySign: 'accounting',
        } as any).format(value);
      } catch (err) {
        // default fallback format for buggy safari 14.1.x users
        return `${currencyCode} ${value}`;
      }
    }

    return '';
  },
  formatDateToIsoStringIgnoringTime(date: Date | string) {
    let dateFormat = globalConstants.dateFormat;
    const { userProfile } = useUserStore();

    if (isString(date)) {
      if (moment(date).isValid()) {
        return moment(date).format(dateFormat);
      }

      moment.locale(userProfile?.user.locale.replace('_', '-'));
      dateFormat = globalConstants.dateLocalFormat;
    }

    return moment(date, dateFormat).format(globalConstants.dateFormat);
  },
  formatNumber(value: any) {
    if (!value) {
      return '-';
    }

    return value;
  },
  formatPercentage(value: number, ignoreZero = false) {
    if (value || (value === 0 && !ignoreZero)) {
      return `${(value * 100).toFixed(2)}%`;
    }

    return '';
  },
  gridNumberFormatter(params: any): string {
    return this.formatNumber(params.value).toString();
  },
  gridDateFormatter(params: any, locale: string): string {
    return this.formatDateNoUTC(params.value, locale).toString();
  },
  launchCalendarDateFormatter(date: string, locale: string): string {
    return this.formatDate(date, locale, { day: 'numeric', month: 'short' });
  },
  getTranslationFromTranslateField(localizedString: LocalizedString, locale: keyof LocalizedString): string {
    const empty = '-';

    return (
      localizedString[locale ?? globalConstants.defaultLocale] ??
      localizedString[globalConstants.fallBackLocale] ??
      empty
    );
  },
};
